import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { fetchOfferTags } from 'actions/OfferActions'

interface UseOfferTagsResult {
  tags: Array<{ id: string; name: string }>
  fetching: boolean
}

/**
 * Hook to fetch and access offer tags from Redux store
 * @param offerId - The offer ID to fetch tags for
 * @returns Object containing tags array and fetching status
 */
function useOfferTags(offerId: string | undefined): UseOfferTagsResult {
  const dispatch = useAppDispatch()

  const tagData = useAppSelector(state => {
    if (!offerId) {
      return undefined
    }
    return state.offer.offerTags?.[offerId]
  })

  useEffect(() => {
    if (!offerId) {
      return
    }

    dispatch(fetchOfferTags(offerId))
  }, [dispatch, offerId])

  return {
    tags: tagData?.tags ?? [],
    fetching: tagData?.fetching ?? false,
  }
}

export default useOfferTags
